import React, { useEffect, useState } from "react";
import api from "../../services/api";

// ── Modal Créer Superviseur ──
const ModalCreerSuperviseur = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({ nom: "", prenom: "", email: "", produitId: "" });
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/produits").then(r => setProduits(r.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const body = { nom: form.nom, prenom: form.prenom, email: form.email, role: "Superviseur" };
      if (form.produitId) body.produitId = parseInt(form.produitId);
      await api.post("/auth/creer-compte", body);
      onSuccess("Compte superviseur créé ! Les identifiants ont été envoyés par email.");
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de la création");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: "100%", padding: "0.65rem 0.9rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "0.75rem" };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Nouveau superviseur</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Nom *</label>
          <input value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} placeholder="Diallo" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Prénom *</label>
          <input value={form.prenom} onChange={e => setForm({ ...form, prenom: e.target.value })} placeholder="Ibrahima" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Email *</label>
          <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="ibrahima@email.com" required style={inputStyle} />
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "4px" }}>Produit (optionnel — Cash24 par défaut)</label>
          <select value={form.produitId} onChange={e => setForm({ ...form, produitId: e.target.value })} style={inputStyle}>
            <option value="">Cash24 (défaut)</option>
            {produits.map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}
          </select>
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, marginTop: "0.5rem" }}>
            {loading ? "Création..." : "Créer le compte"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Modal Recharger Caisse ──
const ModalRecharger = ({ superviseur, onClose, onSuccess }) => {
  const [montant, setMontant] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post(`/superviseurs/${superviseur.id}/caisse`, { montant: parseInt(montant) });
      onSuccess("Caisse rechargée avec succès !");
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors du rechargement");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "380px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Recharger caisse — {superviseur.prenom} {superviseur.nom}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Montant (F CFA) *</label>
          <input type="number" value={montant} onChange={e => setMontant(e.target.value)} placeholder="Ex: 500000" required min={1}
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "1.25rem" }} />
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Rechargement..." : "Recharger"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Modal Archiver/Réactiver ──
const ModalArchivage = ({ superviseur, action, onClose, onSuccess }) => {
  const [commentaire, setCommentaire] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.put(`/superviseurs/${superviseur.id}/${action === "archiver" ? "archiver" : "reactiver"}`, { commentaire });
      onSuccess(`Superviseur ${action === "archiver" ? "archivé" : "réactivé"} avec succès !`);
    } catch (err) {
      setError(err.response?.data?.error || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0, color: action === "archiver" ? "#dc2626" : "#16a34a" }}>
            {action === "archiver" ? "Archiver" : "Réactiver"} {superviseur.prenom} {superviseur.nom}
          </h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Commentaire</label>
          <textarea value={commentaire} onChange={e => setCommentaire(e.target.value)} placeholder="Raison..." rows={3}
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white", resize: "none", marginBottom: "1.25rem" }} />
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: action === "archiver" ? "#dc2626" : "linear-gradient(135deg, #16a34a, #22c55e)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Traitement..." : action === "archiver" ? "Archiver" : "Réactiver"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Modal Affecter Commercial ──
const ModalAffecterCommercial = ({ superviseur, onClose, onSuccess }) => {
  const [commerciaux, setCommerciaux] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/commercials").then(res => setCommerciaux(res.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post(`/superviseurs/${superviseur.id}/commerciaux`, { commercialId: parseInt(selectedId) });
      onSuccess("Commercial affecté avec succès !");
    } catch (err) {
      setError(err.response?.data?.error || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Affecter un commercial à {superviseur.prenom} {superviseur.nom}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Choisir un commercial *</label>
          <select value={selectedId} onChange={e => setSelectedId(e.target.value)} required
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "1.25rem" }}>
            <option value="">-- Sélectionner --</option>
            {commerciaux.map(com => (
              <option key={com.id} value={com.id}>{com.prenom} {com.nom}</option>
            ))}
          </select>
          <button type="submit" disabled={loading || !selectedId} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Affectation..." : "Affecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Page principale ──
const Superviseurs = () => {
  const [superviseurs, setSuperviseurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [showModalCreer, setShowModalCreer] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [commerciauxParSup, setCommerciauxParSup] = useState({});
  const [expandedSup, setExpandedSup] = useState(null);

  const fetchSuperviseurs = async () => {
    try {
      const res = await api.get("/commercials/dashboard/admin");
      setSuperviseurs(res.data.performance_par_superviseur || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuperviseurs();
  }, []);

  const fetchCommerciauxSup = async (supId) => {
    if (expandedSup === supId) { setExpandedSup(null); return; }
    try {
      const res = await api.get(`/superviseurs/${supId}/commerciaux`);
      setCommerciauxParSup(prev => ({ ...prev, [supId]: res.data }));
      setExpandedSup(supId);
    } catch (err) {
      console.error(err);
    }
  };

  const handleRetirer = async (supId, comId) => {
    try {
      await api.delete(`/superviseurs/${supId}/commerciaux/${comId}`);
      setCommerciauxParSup(prev => ({
        ...prev,
        [supId]: prev[supId].filter(c => c.id !== comId)
      }));
      fetchSuperviseurs();
    } catch (err) {
      console.error(err);
    }
  };

  const handleSuccess = (msg) => {
    setModal(null);
    setShowModalCreer(false);
    setSuccessMsg(msg);
    fetchSuperviseurs();
    setTimeout(() => setSuccessMsg(""), 3000);
  };

  return (
    <>
      {showModalCreer && <ModalCreerSuperviseur onClose={() => setShowModalCreer(false)} onSuccess={handleSuccess} />}
      {modal?.type === "recharger" && <ModalRecharger superviseur={modal.superviseur} onClose={() => setModal(null)} onSuccess={handleSuccess} />}
      {modal?.type === "archiver" && <ModalArchivage superviseur={modal.superviseur} action="archiver" onClose={() => setModal(null)} onSuccess={handleSuccess} />}
      {modal?.type === "reactiver" && <ModalArchivage superviseur={modal.superviseur} action="reactiver" onClose={() => setModal(null)} onSuccess={handleSuccess} />}
      {modal?.type === "affecter" && <ModalAffecterCommercial superviseur={modal.superviseur} onClose={() => setModal(null)} onSuccess={handleSuccess} />}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Superviseurs</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>{superviseurs.length} superviseur(s)</p>
        </div>
        <button onClick={() => setShowModalCreer(true)} style={{ padding: "0.6rem 1.25rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "13px", borderRadius: "9999px", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
          <svg width="14" height="14" fill="none" stroke="white" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Nouveau superviseur
        </button>
      </div>

      {successMsg && (
        <div style={{ marginBottom: "1rem", padding: "0.75rem 1rem", backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", color: "#16a34a", fontSize: "13px" }}>{successMsg}</div>
      )}

      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Chargement...</div>
        ) : superviseurs.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>👤</div>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucun superviseur</p>
          </div>
        ) : (
          superviseurs.map((sup, i) => (
            <div key={sup.id} style={{ padding: "1rem 1.25rem", borderBottom: i < superviseurs.length - 1 ? "0.5px solid #f3f4f6" : "none", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: sup.actif ? "#f3e8ff" : "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "500", color: sup.actif ? "#7c3aed" : "#9ca3af", flexShrink: 0 }}>
                {sup.nom?.charAt(0)}{sup.prenom?.charAt(0)}
              </div>
              <div style={{ flex: 1, minWidth: "150px" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                  {sup.prenom} {sup.nom}
                  <span style={{ fontSize: "10px", backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "1px 6px", borderRadius: "4px", fontWeight: "500" }}>{sup.produit_nom || "Cash24"}</span>
                  {!sup.actif && <span style={{ fontSize: "11px", backgroundColor: "#f3f4f6", color: "#6b7280", padding: "1px 6px", borderRadius: "4px" }}>Archivé</span>}
                </div>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                  {sup.nb_commerciaux} commercial(aux) · Caisse : {Number(sup.caisse_fixe || 0).toLocaleString("fr-FR")} F
                </div>
              </div>

              {/* Boutons actions */}
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {sup.actif && (
                  <>
                    <button onClick={() => fetchCommerciauxSup(sup.id)}
                      style={{ padding: "0.4rem 0.9rem", backgroundColor: "#f9fafb", color: "#374151", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                      {expandedSup === sup.id ? "Masquer" : `Commerciaux (${sup.nb_commerciaux})`}
                    </button>
                    <button onClick={() => setModal({ type: "recharger", superviseur: sup })}
                      style={{ padding: "0.4rem 0.9rem", backgroundColor: "#f3e8ff", color: "#7c3aed", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                      Recharger
                    </button>
                    <button onClick={() => setModal({ type: "affecter", superviseur: sup })}
                      style={{ padding: "0.4rem 0.9rem", backgroundColor: "#E6F1FB", color: "#185FA5", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                      Affecter
                    </button>
                    <button onClick={() => setModal({ type: "archiver", superviseur: sup })}
                      style={{ padding: "0.4rem 0.9rem", backgroundColor: "#fef2f2", color: "#dc2626", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                      Archiver
                    </button>
                  </>
                )}
                {!sup.actif && (
                  <button onClick={() => setModal({ type: "reactiver", superviseur: sup })}
                    style={{ padding: "0.4rem 0.9rem", backgroundColor: "#f0fdf4", color: "#16a34a", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                    Réactiver
                  </button>
                )}
              </div>

              {/* Commerciaux affectés */}
              {expandedSup === sup.id && (
                <div style={{ width: "100%", marginTop: "0.75rem", paddingTop: "0.75rem", borderTop: "0.5px solid #f3f4f6" }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>Commerciaux affectés :</div>
                  {(commerciauxParSup[sup.id] || []).length === 0 ? (
                    <div style={{ fontSize: "12px", color: "#9ca3af" }}>Aucun commercial affecté</div>
                  ) : (
                    (commerciauxParSup[sup.id] || []).map(com => (
                      <div key={com.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "4px 0" }}>
                        <span style={{ fontSize: "12px", color: "#374151" }}>{com.prenom} {com.nom}</span>
                        <button onClick={() => handleRetirer(sup.id, com.id)}
                          style={{ padding: "2px 8px", backgroundColor: "#fef2f2", color: "#dc2626", border: "none", borderRadius: "6px", fontSize: "11px", cursor: "pointer" }}>
                          Retirer
                        </button>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default Superviseurs;